import type { ButtonProps } from '@/app/components/button';
import type { ServiceCenterImageWithCTAProps } from '@/app/components/sections/service/service-center/image-with-cta/types';
import type { PrivilegeBadgeProps } from '@/app/components/sections/service/service-center/privileges/types';
import { MY_ISUZU_APP_STORE_URLS } from '@/app/constants/short-io';

const isProduction = process.env.NEXT_PUBLIC_ENV === 'prd';

export const BUTTON_REGISTER_MY_ISUZU_APP: ButtonProps = {
  children: 'สมัครผ่าน my-ISUZU App',
  target: '_blank',
  href: isProduction
    ? 'https://m.isuzu-tis.com/wty'
    : 'https://ab.isuzu-tis.com/wty',
} as const;

export const BUTTON_REGISTER_MY_MEMBER_APP: ButtonProps = {
  children: 'ดาวน์โหลด my-ISUZU',
  target: '_blank',
  color: 'black',
  href: isProduction
    ? 'https://m.isuzu-tis.com/mm'
    : 'https://ab.isuzu-tis.com/mm',
} as const;

export const BUTTON_DETAIL_MY_ISUZU: ButtonProps = {
  children: 'รายละเอียด my-ISUZU',
  href: '/privileges/my-isuzu',
  color: 'white',
} as const;

export const MY_ISUZU_APPLICATION_DATA: ServiceCenterImageWithCTAProps = {
  title: 'รับสิทธิการเป็นสมาชิก <span>เพียงลงทะเบียนกับ</span>',
  variant: 'red',
  buttons: [BUTTON_DETAIL_MY_ISUZU],
  logo: {
    src: 'https://assets.isuzu-tis.com/logo_my_isuzu_46cc96d4ed.svg',
    alt: 'Logo MY Isuzu',
    height: 30,
    width: 215,
  },
  image: {
    src: 'https://assets.isuzu-tis.com/my_isuzu_application_106ef291c4.png',
    height: 600,
    width: 1208,
    alt: 'MY Isuzu',
  },
} as const;

export const QR_CODE = 'https://assets.isuzu-tis.com/qr_code_a5d584edb6.png';

export const MY_ISUZU_DOWNLOAD_DATA: PrivilegeBadgeProps[] = [
  {
    href: MY_ISUZU_APP_STORE_URLS.IOS,
    target: '_blank',
    children: 'Download on the App Store',
    image: {
      src: 'https://assets.isuzu-tis.com/app_store_3c483b9105.svg',
      alt: 'ดาวน์โหลดบน App Store',
      width: 96,
      height: 32,
      aspectRatio: 'calculate',
    },
  },
  {
    href: MY_ISUZU_APP_STORE_URLS.ANDROID,
    target: '_blank',
    children: 'Get it on Google Play',
    image: {
      src: 'https://assets.isuzu-tis.com/google_play_6dbaf4eb8e.svg',
      alt: 'ดาวน์โหลดบน Google Play',
      width: 108,
      height: 32,
      aspectRatio: 'calculate',
    },
  },
] as const;

export const MY_ISUZU_APPOINTMENT = isProduction
  ? 'https://m.isuzu-tis.com/sappt'
  : 'https://ab.isuzu-tis.com/sappt';
